export default __webpack_public_path__ + "static/media/bim.c226e97c.mp4";